<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="page-title">
          {{ $t('data.balance_details') }}
        </div>
      </el-col>
    </el-row>
    <el-button style="background: none; margin-bottom: 24px;" plain type="info" @click="onClickBack('Financial_Manage_Balance')">{{ $t('data.back_to_balance') }}</el-button>

    <div class="balance-record page-container">
      <div class="filter-container">
        <div class="filter-container-tag">
          {{ $t('components.activity') }}
        </div>
        <span class="transTime">{{ $t('merchantAccount.balance_record_type') }}:</span>
        <el-select
          v-model="search.balance_type"
          :placeholder="$t('merchantAccount.balance_record_type')"
          class="search-frame provisions-bank provisions-frame"
          clearable
        >
          <el-option
            v-for="(item,index) in balanceTypeArr"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <span class="transTime">{{ $t('components.date') }}:</span>
        <!-- 时间 -->
        <el-date-picker
          v-model="search.times"
          class="mb-10 picker"

          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="~"
          :start-placeholder="$t('components.start_date')"
          :end-placeholder="$t('components.end_date')"
        />
        <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
      </div>
      <div class="tableContainer">
        <!-- 列表 -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
          class="tableContainer"
        >
          <!--        <el-table-column label="ID" align="center">-->
          <!--          <template slot-scope="scope">-->
          <!--            {{ scope.row.id }}-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <el-table-column :label="$t('merchantAccount.init_balance')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.init_balance | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('merchantAccount.current_balance')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.balance | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!--
        <el-table-column :label="$t('merchantAccount.in_transit_settlement_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fund_settlement_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

          <el-table-column :label="$t('merchantAccount.transaction_amount')" align="center">
            <template slot-scope="scope">
              <span>{{ Math.abs(scope.row.amount) | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.fee')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fee | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.balance_record_type')" width="200" align="center">
            <template slot-scope="scope">
              <el-tag style="color: #FFFFFF" :color="getAgentBalanceTypeMapColor(scope.row.balance_type)" :type="getBalanceTypeStyle(scope.row.balance_type)">{{ getAgentBalanceTypeMap(scope.row.balance_type) }} </el-tag>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.create_time')" align="center">
            <template slot-scope="scope">
              {{ scope.row.create_time }}
            </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('merchantAccount.update_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.update_time }}</span>
          </template>
        </el-table-column> -->

          <el-table-column :label="$t('merchantAccount.note')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import { fetchMchBalanceInfo, fetchMchBalanceInfoAllList } from '@/api/settlement/settlement'
import { agentBalanceTypeMap } from '@/utils/maps'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Balance_Trans_Detail',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        times: [appointDate(-3), appointDate()],
        balance_type: ''
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    balanceTypeArr() {
      return agentBalanceTypeMap()
    },
    getAgentBalanceTypeMap() {
      return function(value) {
        return agentBalanceTypeMap(value).label
      }
    },
    getAgentBalanceTypeMapColor() {
      return function(value) {
        return agentBalanceTypeMap(value).color
      }
    },
    getBalanceTypeStyle() {
      return function(value) {
        return agentBalanceTypeMap(value).type
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getMchBalanceInfo(data) {
      this.listLoading = true
      fetchMchBalanceInfo(data).then(res => {
        if (res.code === 10000) {
          const { total, list = [] } = res.data || {}
          this.listQuery.total = total
          this.listQuery.page = data.page ? data.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { times = [], balance_type } = this.search
      let params = { start_date: times && times[0], balance_type, end_date: times && times[1], ...otherParams }
      params = filterEmptyAttr(params)
      if (!balance_type) {
        params.balance_type = 'all_agent'
      }
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getMchBalanceInfo(params)
    },

    onClickDowmloadBtn() {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 90)) {
        this.$message.warning('The maximum date range  is limited to 90 days, please select again')
        return
      }
      const params = this.getParams()
      this.downloading = true
      fetchMchBalanceInfoAllList(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Start downloading!')
          this.handleXlsxData(res.data).then((downloadData) => {
            exportXlsx(downloadData, 'Balance_Record')
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('merchantAccount.init_balance'),
        this.$t('merchantAccount.current_balance'),
        this.$t('merchantAccount.transaction_amount'),
        this.$t('data.fee'),
        this.$t('merchantAccount.balance_record_type'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.note')
      ]]

      const toDivide100 = this.$options.filters['toDivide100']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            toDivide100(tr.init_balance),
            toDivide100(tr.balance),
            toDivide100(tr.amount),
            toDivide100(tr.fee),
            this.getAgentBalanceTypeMap(tr.balance_type),
            tr.create_time,
            tr.remark
          ])
        })
      }
      return Promise.resolve(rows)
    },

    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickBack(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-breadcrumbs{
  display: flex;
  justify-items: center;
  margin: 32px 0;
  color: #3855F1;
  cursor: pointer;
  .icon-back{
    position: relative;
    top: -1px;
    margin-right: 12px;
    margin-top: 2px;
  }
}
.balance-record{
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    position: relative;
    text-align: right;
    padding-bottom: 22px;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
